import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import {
  QueryClient,
  QueryClientProvider,
  keepPreviousData,
} from "@tanstack/react-query";
import { KeycloakProvider } from "@/auth/KeycloakProvider";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import App from "@/App";
import "@/styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale-while-revalidate by default: keep the previous data
      // visible while a re-fetch is in flight so a 1s API blip
      // never blanks a table.
      staleTime: 30_000,
      retry: 2,
      retryDelay: (attemptIndex) =>
        Math.min(1000 * 2 ** attemptIndex, 5_000),
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <KeycloakProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </KeycloakProvider>
  </React.StrictMode>
);
